// @flow
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import Grid from '@material-ui/core/Grid';
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import InfoIcon from '@material-ui/icons/Info';
import { Typography } from "@material-ui/core";
import { grey, red, yellow, blue } from '@material-ui/core/colors';
import { PriorityLevels } from "./types";

const styles = theme => ({
    errorIcon: {
        marginRight: theme.spacing(2),
        fill: red[500],
    },
    warningIcon: {
        marginRight: theme.spacing(2),
        fill: yellow[700],
    },
    infoIcon: {
        marginRight: theme.spacing(2),
        fill: blue[500],
    },
    acknowledgedIcon: {
        marginRight: theme.spacing(2),
        fill: grey[400],
    },
    label: {
        fontSize: 12,
        color: grey[600],
        maxHeight: 30,
        overflow: 'hidden',
    },
});

type Props = {
    id: number,
    label: string,
    priorityLevel: PriorityLevels,
    acknowledged: boolean,
    onClick: Function,
    classes: {
        acknowledgedIcon: string,
        errorIcon: string,
        warningIcon: string,
        infoIcon: string,
        label: string,
    },
};

const NotificationListItem = (props: Props) => (
    <ListItem button onClick={ e => props.onClick(e, props.id)}>
        <Grid container>
            <Grid item>
                {
                    props.priorityLevel === 'Critical' &&
                    <ErrorIcon className={props.acknowledged ? props.classes.acknowledgedIcon : props.classes.errorIcon} />
                }
                {
                    props.priorityLevel === 'Warning' &&
                    <WarningIcon className={props.acknowledged ? props.classes.acknowledgedIcon : props.classes.warningIcon} />
                }
                {
                    props.priorityLevel === 'Info' &&
                    <InfoIcon className={props.acknowledged ? props.classes.acknowledgedIcon : props.classes.infoIcon} />
                }
            </Grid>
            <Grid item xs>
                <Typography
                    style={{
                        textDecoration: props.acknowledged ? 'line-through' : 'inherit',
                    }}
                    className={props.classes.label}
                >
                    {props.label}
                </Typography>
            </Grid>
        </Grid>
    </ListItem>
);

export default withStyles(styles)(NotificationListItem);
